import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import logo from '../assets/logo.png';
import login_bg from '../assets/login_bg.jpg';
import logo_worded_only from '../assets/logo_worded_only.png';
import { callApi, CDN_URL, formatDate, formatMoney, getCookie, getInlineLoader, setCookie } from "../Helpers";
import { MdArrowCircleLeft, MdArrowCircleRight, MdCircle, MdLock, MdLogin, MdOutlinePhonelinkLock, MdPassword, MdPerson, MdPhone, MdPhoneAndroid, MdPhonelinkLock, MdPhoneLocked } from "react-icons/md";
import { GiLovers, GiTalk } from "react-icons/gi";
import { FaUserDoctor } from "react-icons/fa6";
import { STR_AMOUNT, STR_AT_LEAST_ONE_IMAGE, STR_AVAILABLE_QUANTITY, STR_CANCEL_ORDER, STR_CANCELLATION_REASON, STR_CATEGORY, STR_COULD_NOT_FETCH_DATA, STR_CROPS, STR_DATE, STR_DELIVERY_LOCATION, STR_IMAGES, STR_INVALID_LOCATION, STR_INVALID_QUANTITY, STR_INVALID_TITLE, STR_INVALID_UNIT_PRICE, STR_ITEM_DESCRIPTION, STR_ITEM_LOCATION, STR_ITEM_TITLE, STR_LIVESTOCK, STR_MOQ, STR_OPTIONAL, STR_ORDER_NOTES, STR_ORDER_QUANTITY, STR_OVERALL_COST, STR_PACKAGING_COST, STR_PENDING, STR_PLACE_ORDER, STR_PLACE_YOUR_ORDER, STR_POST_ITEM, STR_REJECTED, STR_SHIPPING_COST, STR_STATUS, STR_SUBMIT, STR_SUCCESS, STR_TOTAL_ORDER_PRICE, STR_TRANSACTION_FEES, STR_UNIT, STR_UNIT_PRICE, STR_VIEW_SALE, STR_WITHDRAWAL_ACCOUNT_NAME, STR_WITHDRAWAL_ACCOUNT_NUMBER, STR_WITHDRAWAL_AMOUNT, STR_WITHDRAWAL_METHOD } from "../Strings";
import NapaAddressPicker from "../ones/NapaAddressPicker";
import ImageSlider from "../ones/ImagesSlider";
import OpSuccessWidget from "../ones/OpSuccessWidget";
import OrderInfo from "../ones/OrderInfo";
import OrderReceipt from "../ones/OrderReceipt";


export default function View({ uuid }) {

	const appContext = useContext(AppContext);

	const [loading, setLoading] = useState(false);
	const [ready, setReady] = useState(false);

	const [data, setData] = useState(null);
	

	async function init() {
		setReady(false);
		await Promise.all([
			getData(),
		])
		setReady(true)
	}

	

	async function getData() {
		await callApi("get-revenue-data", { revenueUuid: uuid }).then((response) => {
			if(response.status === 1) {
				setData(response.data);
			} else {
				appContext.tellError(STR_COULD_NOT_FETCH_DATA[appContext.language]);
			}
		})
	}

	

	useEffect(() => {
		init();
	}, [])

	

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);
		
		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [loading])

	
	if (ready && data) {
		return (
			<div className="container">
				<div className="row">
					
				

					<div className="col-12 col-md-6 mt-2 mb-2">
						<label className="form-label text-secondary">{STR_AMOUNT[appContext.language]}</label>
						<h6
							style={{
								fontSize: "22px",
							}}
							className="font-bold"
						>
							{formatMoney(data.amount)}
						</h6>
					</div>

					<div className="col-12 col-md-6 mt-2 mb-2">
						<label className="form-label text-secondary">{STR_DATE[appContext.language]}</label>
						<h6
							style={{
								fontSize: "14px",
							}}
							className="font-bold"
						>
							{formatDate(data.dateCreated)}
						</h6>
					</div>

					<div className="col-12 col-md-12 mt-2 mb-2 text-end">
						<button
							className="btn btn-padded btn-rounded btn-outline-dark"
							onClick={() => {
								appContext.navTo({
									item: 'view',
									subItem: 'sale',
									extraItem: data.orderUuid,
								})
							}}
						>
							{STR_VIEW_SALE[appContext.language]}
						</button>
					</div>

				</div>
			</div>
		)
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}
	
}